const OPEN = 'open';
const MOBILE_NAV_OPEN = 'mobile-nav-open';
const MOBILE_NAV_BACKDROP = 'mobile-nav-backdrop';
const SEARCH_EXPANDED_CLASS = 'navbar-search-expanded';
const $body = $('body');
const $backdrop = $(`<div class="${MOBILE_NAV_BACKDROP} fade show"></div>`);

export default class Navbar {
	static toggleNavbarForMobile() {
		$('[data-toggle=".offcanvas-collapse"]').on('click', (event) => {
			const target = $(event.currentTarget).data('toggle');
			const $target = $(target);
			this.toggleNavbar($target);
			$(`.${MOBILE_NAV_BACKDROP}`).on('click', () => {
				this.toggleNavbar($target);
			});
		});
	}

	static toggleNavbar($target) {
		$target.toggleClass(OPEN);
		$body.toggleClass(MOBILE_NAV_OPEN);
		if ($body.hasClass(MOBILE_NAV_OPEN)) {
			$('.navbar-primary').prepend($backdrop);
		} else {
			$backdrop.remove();
		}
	}

    static search() {
        // Expand the search bar for desktop when the search button is clicked
        const $navbarPrimary = $('.navbar-primary');
        const $input = $('input[name=query]');

        $('.navbar-search-expander').on('click', () => {
            $navbarPrimary.addClass(SEARCH_EXPANDED_CLASS);
            $input.trigger('focus');
        });

        $input.on('blur', () => {
            // Give enough time for the submit button to be clicked
            setTimeout(() => {
                $navbarPrimary.removeClass(SEARCH_EXPANDED_CLASS);
            }, 250);
        });
    }
}

